//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IconView from "@/components/objects/IconView.vue";
import { DesignExtra } from "@/utils/dto/objects.js";
import { adjustColorBrightness, buildMaskStyle } from "@/utils/helpers.js";
import { BUILD_STORAGE_PATH, STORAGE_BACKGROUND_PATH } from "@/constants/ui.js";
import TheMaskIcon from '@/components/objects/TheMaskIcon.vue';


export default {
  name: 'WithBg',
  components: { IconView, TheMaskIcon },
  inject: {
    specialProject: {
      default: false
    }
  },
  props: {
    tgb: {
      type: Object,
      default: () => { }
    },
    objectLabel: {
      type: String,
      required: false,
      default: () => ''
    },
    objectId: {
      type: String,
      default: ''
    },
    design: {
      type: String,
    },
    design_extra: {
      type: [Object, DesignExtra],
      default: () => { }
    },
    template: {
      type: Object,
      default: () => null
    },
    theme: {
      type: String,
    },
    listInfo: {
      type: Object,
      default: () => ({})
    },
    user: {
      type: Object,
      default: () => { }
    },
    isArt: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      domId: '',
      bgImageUrl: '',
    }
  },
  computed: {
    paletteList() {
      return this.$store.state["property_templates"]["consts"].palette;
    },
    bgPalette() {
      if (this.design_extra?.bg?.palette && this.paletteList) {
        return this.paletteList.filter(el => el.id === this.design_extra.bg.palette)[0];
      }

      return null;
    },
    blockBorderPalette() {
      if (this.design_extra?.block_border?.palette && this.paletteList) {
        return this.paletteList.filter(el => el.id === this.design_extra.block_border.palette)[0];
      }

      return null;
    },
    iconBorderPalette() {
      if (this.design_extra?.icon_border?.palette && this.paletteList) {
        return this.paletteList.filter(el => el.id === this.design_extra.icon_border.palette)[0];
      }

      return null;
    },
    iconBgPalette() {
      if (this.design_extra?.icon_bg?.palette && this.paletteList) {
        return this.paletteList.filter(el => el.id === this.design_extra.icon_bg.palette)[0];
      }

      return null;
    },
    getTextColor() {
      return this.design_extra?.text?.color ?? null;
    },
    getFirstBlockBg() {
      if (this.getFirstBlockBgGradientEnabled) {
        return `linear-gradient(to ${this.getFirstBlockBgGradientDirection}, ${this.getFirstBlockBgGradientShadowDirection === 'transparent' ? `${this.getFirstBlockBgColor}, transparent` : `${this.getFirstBlockBgColor}, ${adjustColorBrightness(this.getFirstBlockBgColor, 1.20)}`})`
      }
      return this.getFirstBlockBgColor ?? null;
    },
    getFirstBlockBgColor() {
      if (this.design_extra?.first_block?.bg_color) {
        return this.design_extra?.first_block?.bg_color
      }

      return null;
    },
    getFirstBlockBgGradientEnabled() {
      return this.design_extra?.first_block?.gradient_enabled ?? null;
    },
    getFirstBlockBgGradientDirection() {
      return this.design_extra?.first_block?.gradient_direction ?? null;
    },
    getFirstBlockBgGradientShadowDirection() {
      return this.design_extra?.first_block?.gradient_shadow_direction ?? null;
    },
    getFirstBlockTitleColor() {
      return this.design_extra?.first_block?.title_color ?? 'rgba(0, 0, 0, 0.65)' ?? null;
    },
    getBlockBorderColor() {
      let color;
      if (this.blockBorderPalette) {
        color = this.blockBorderPalette.main_color;
      } else if (this.design_extra?.block_border?.color) {
        color = this.design_extra.block_border.color;
      } else {
        return null
      }

      return { border: `2px solid ${color}` }
    },
    getIconBorder() {
      let color;
      if (this.iconBorderPalette) {
        color = this.iconBorderPalette.main_color;
      } else if (this.design_extra?.icon_border?.color) {
        color = this.design_extra.icon_border.color;
      } else {
        return null
      }

      return { border: `1px solid ${color}` }
    },
    getIconBg() {
      if (this.iconBgPalette) {
        return { backgroundColor: this.iconBgPalette.main_color };
      } else if (this.design_extra?.icon_bg?.color) {
        return { backgroundColor: this.design_extra.icon_bg.color }
      }

      return null
    },
    getBgGradientEnabled() {
      return this.design_extra?.bg?.gradient_enabled ?? null;
    },
    getBgGradientDirection() {
      return this.design_extra?.bg?.gradient_direction ?? null;
    },
    getBgGradientShadowDirection() {
      return this.design_extra?.bg?.gradient_shadow_direction ?? null;
    },
    getBgColor() {
      if (this.bgPalette) {
        return this.bgPalette.main_color;
      } else if (this.design_extra?.bg?.color) {
        return this.design_extra.bg.color
      }

      return null;
    },
    getBg() {
      if (this.getBgGradientEnabled) {
        return `linear-gradient(to ${this.getBgGradientDirection}, ${this.getBgGradientShadowDirection === 'transparent' ? `${this.getBgColor}, transparent` : `${this.getBgColor}, ${adjustColorBrightness(this.getBgColor, 1.20)}`})`
      }
      return this.getBgColor ?? null;
    },
    getIconColor() {
      return this.design_extra?.icon_color?.color ?? 'black';
    },
    getMask() {
      return this.design_extra?.mask?.name ?? null;
    },
    adjustColorBrightness() {
      return adjustColorBrightness
    },
    maskStyle() {
      return buildMaskStyle(this.getMask)
    },
    imagePath() {
      if (this.tgb.background) {
        if (this.tgb.background.type === 'image') {
          return this.bgImageUrl;
        } else {
          return BUILD_STORAGE_PATH(this.isArt ? 'materials' : 'object_tgb_images', this.tgb.background.image_depot_id || this.tgb.background.image_uploaded);
        }
      } else {
        return ''
      }
    },
  },
  async mounted() {
    this.domId = `tgbs-${this.listInfo.id}`;
    if (this.tgb.background && this.tgb.background.background_id) {
      await this.$store.dispatch('backgrounds/fetchPublicObject', this.tgb.background.background_id).then((item) => {
        this.bgImageUrl = this.$addServerPath(`${STORAGE_BACKGROUND_PATH}${item.picto}`);
      })
    }
  },
}
